import { getTodayDate, stringToDate, getDifferenceOnDays } from '@hc-frontend/utils'

function validate(signatureDocument): string | undefined {
  // By default the getDifferenceOnDays function is returning 1 for the same date
  // The start date should be at least the 1 day after the current date
  const daysToExpire = getDifferenceOnDays(
    getTodayDate(),
    stringToDate(signatureDocument.hcStorage.sdate)
  )
  if (daysToExpire < 2) {
    return 'The esignature sdate is already expired'
  }

  return
}

export default validate
